<script lang="ts">
  import CornerFrame from '$lib/components/CornerFrame.svelte';

  interface Section {
    id: string;
    label: string;
  }

  interface Props {
    sections: Section[];
  }

  let { sections }: Props = $props();

  let activeSection = $state('');
  let pillBarEl: HTMLElement | undefined = $state();

  $effect(() => {
    const elements = sections
      .map(s => document.getElementById(s.id))
      .filter((el): el is HTMLElement => el !== null);

    if (elements.length === 0) return;

    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            activeSection = entry.target.id;
          }
        }
      },
      { rootMargin: '-20% 0px -60% 0px' }
    );

    for (const el of elements) {
      observer.observe(el);
    }

    return () => observer.disconnect();
  });

  // Auto-scroll mobile pill bar to keep active pill visible
  $effect(() => {
    if (!pillBarEl) return;
    const activePill = pillBarEl.querySelector(`[data-section="${activeSection}"]`);
    if (activePill instanceof HTMLElement) {
      activePill.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    }
  });

  function scrollTo(id: string) {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  }
</script>

<!-- Mobile: horizontal sticky pill bar -->
<nav
  bind:this={pillBarEl}
  class="lg:hidden sticky top-0 z-10 bg-[#0d0d0d]/95 backdrop-blur-sm border-b border-[#333335] flex gap-2 px-4 py-3 overflow-x-auto scrollbar-hide"
>
  {#each sections as section}
    <button
      data-section={section.id}
      onclick={() => scrollTo(section.id)}
      class="shrink-0 font-mono text-[12px] px-3 py-1.5 rounded-full border transition-colors whitespace-nowrap cursor-pointer
        {activeSection === section.id
          ? 'border-white text-white bg-white/10'
          : 'border-[#333335] text-[#878787] hover:text-white hover:border-[#656565]'}"
    >
      {section.label}
    </button>
  {/each}
</nav>

<!-- Desktop: fixed sidebar -->
<nav class="hidden lg:block fixed left-[max(1rem,calc(9.03%-180px))] top-1/2 -translate-y-1/2 z-20">
  <CornerFrame bg="bg-white" borderColor="rgba(211, 211, 211, 1)" cornerColor="#020202" class="px-5 py-4">
    <ul class="flex flex-col gap-3">
      {#each sections as section}
        <li>
          <button
            onclick={() => scrollTo(section.id)}
            class="font-mono text-[12px] text-left transition-colors cursor-pointer leading-tight
              {activeSection === section.id ? 'text-black' : 'text-[#878787]/60 hover:text-[#5C5855]'}"
          >
            {section.label}
          </button>
        </li>
      {/each}
    </ul>
  </CornerFrame>
</nav>
